export default "__VITE_ASSET__B1Huo09X__"